import { useState } from 'react';
import Seo from '@/components/shared/Seo';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import { Button } from '@/components/ui/button';
import PeopleContent from '@/components/explore/desktop/people/PeopleContent';
import SlidingModal from '@/components/home/mobile/SlidingModal';
import ReferPage from '@/pages/refer';
export type TFeedMode = 'Feed' | 'Following' | 'Followers' | 'Requests';
export default function FeedPage() {
  const [showReferModal, setShowReferModal] = useState(false);
  return <div className='bg-genius-indigo h-screen max-h-screen flex flex-col' data-sentry-component="FeedPage" data-sentry-source-file="index.tsx">
      <Seo noindex nofollow title='Feed • Follow what your friend are doing' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      <FullScreenGuard data-sentry-element="FullScreenGuard" data-sentry-source-file="index.tsx">
        <div className='w-full ta-c px-3'>
          <Button className='rounded-full w-full h-[56px] my-4' variant='pink' onClick={() => setShowReferModal(true)} data-sentry-element="Button" data-sentry-source-file="index.tsx">
            Refer Friends
          </Button>
        </div>
        <PeopleContent setShowReferModal={setShowReferModal} data-sentry-element="PeopleContent" data-sentry-source-file="index.tsx" />
      </FullScreenGuard>
      <SlidingModal isOpen={showReferModal} onClose={() => setShowReferModal(false)} data-sentry-element="SlidingModal" data-sentry-source-file="index.tsx">
        <ReferPage data-sentry-element="ReferPage" data-sentry-source-file="index.tsx" />
      </SlidingModal>
    </div>;
}